import { ReactNode } from 'react';

export interface FooterProps {
    /** Footer height (px number or CSS string). Defaults to fitting its content. */
    height?: number | string;
    children?: ReactNode;
}

/**
 * Bottom bar content for StandardModal (e.g. Back / Save & Continue).
 */
export const Footer = ({ height, children }: FooterProps) => {
    return (
        <div
            className='standardModalFooter'
            style={height !== undefined ? { flexBasis: height } : undefined}
        >
            {children}
        </div>
    );
};
